import { render, staticRenderFns } from "./CoursewareSharedItems.vue?vue&type=template&id=06428dde&"
import script from "./CoursewareSharedItems.vue?vue&type=script&lang=js&"
export * from "./CoursewareSharedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports